import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5nhxjdyopf: FaireBrandEntity = {
  token: "b_5nhxjdyopf",
  type: "brand",
  name: "Natural Outcome Skincare",
  avatarUrl:
    "https://cdn.faire.com/fastly/109850a05bc1d6462ea31459e4b9fcd7ecf710dcccc82137872dcbe5090524dd.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/1d255ca4262eb6220479843190582d8fb2ad7310e198fca4cf904dec1dc9e64c.png",
  logoUrl:
    "https://cdn.faire.com/fastly/109850a05bc1d6462ea31459e4b9fcd7ecf710dcccc82137872dcbe5090524dd.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1d255ca4262eb6220479843190582d8fb2ad7310e198fca4cf904dec1dc9e64c.png",
  location: "New York, NY, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 27,
  isInsider: true,
  description:
    "Simplify your skincare routine with Natural Outcome. Our experienced team offers practical, effective products made with natural ingredients and made in our own USA manufacturing facility for highest quality control. We strive to keep our products vegan, cruelty-free, sulfate-free, paraben-free, and as clean as possible. Our focus is on results, not branding. Easy-to-understand packaging for specific skin needs, formulated with top industry standards at affordable prices. Quality, simplicity, and responsibility - the mission of Natural Outcome Skincare.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:33.083Z",
    importedBy: "entity-db-cli",
  },
};
